export default __webpack_public_path__ + "static/media/bg-titre-header-arrondi.4755a2f6.webp";